// Shared component for resource listing pages.
// Data is fetched per-page via getStaticPaths + getStaticProps.
import { attachResourceListingPage } from "~/modules/resources";

// Components
import Listing from "~/components/templates/resource/listing";
import PageTransition from "~/components/motion/page-transition";
import Error from "~/pages/_error";

// Contexts
import ContentContext from "~/context/content";
import { FilterContextProvider } from "~/context/resource-filter";

const PostListingPage = ({ data, error, _paging, type, slug, taxonomy }) => {
    if (!data || error) return <Error />;

    data = attachResourceListingPage(data, type);

    return (
        <PageTransition>
            <ContentContext
                layout="listing"
                type={type}
                data={data}
                taxonomy={{ slug, type: taxonomy }}
            >
                <FilterContextProvider>
                    <Listing resources={data} paging={_paging} type={type} />
                </FilterContextProvider>
            </ContentContext>
        </PageTransition>
    );
};

export default PostListingPage;
